import React from 'react';
import styled, { css } from 'styled-components/macro';
import { CustomScroll } from '@yme/atoms/custom-scroll';
import { MiniButton } from '@yme/atoms/mini-button';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { ButtonsGroupInnerStyled } from '@yme/atoms/modal-footer/styled';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { colorBlackTransparent100, colorCoreBlack300, colorCoreBlack900Base, colorCoreGray1000Base, colorCoreGray500, colorWhiteTransparent300, extraSecondGrayColor, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles } from '@yme/utils/styles';
export const boxStyled = css `
  border-radius: ${CORNER_RADIUS.s};
  border: 1px solid ${colorCoreGray500};
  background: ${colorWhiteTransparent300};
  display: flex;
  align-items: center;
  padding: 8px;
  box-sizing: border-box;

  &:hover {
    background: ${colorBlackTransparent100};
  }
`;
const simpleFilterListReset = css `
  margin: 0;
  padding: 0;
`;
export const FilterDropdownWrapperStyled = styled(FlexWrapper) `
  position: relative;
  width: 100%;

  color: ${colorCoreBlack900Base};
`;
export const FilterClearMiniButtonStyled = styled(MiniButton) `
  padding: 0;

  span:first-child {
    padding-right: 8px;
  }
`;
export const FilterButtonStyled = styled.button `
  ${getTextStyles('Ubuntu', 400, 14, 20)}

  box-sizing: border-box;
  width: 100%;
  height: 44px;

  color: ${colorCoreBlack300};
  background-color: ${colorWhiteTransparent300};
  border: 1px solid ${colorCoreGray500};
  border-radius: ${CORNER_RADIUS.s};

  text-align: ${({ isRightToLeft }) => (isRightToLeft ? 'right' : 'left')};
  padding: ${({ isRightToLeft }) => (isRightToLeft ? '0 16px 0 34px' : '0 34px 0 16px')};

  &:hover {
    border-color: ${colorCoreBlack900Base};
  }
`;
export const FilterButtonWrapperStyled = styled.div `
  position: relative;
  width: 100%;
  min-width: 231px;

  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
`;
export const FilterChildWrapper = styled.div `
  position: absolute;
  top: calc(100% + 8px);
  width: 100%;
  z-index: ${Z_INDEX.level9};
`;
export const FilterLabelStyled = styled.div `
  ${getTextStyles('Ubuntu', 500, 14, 20)}

  ${({ isHorizontal, isTitleFormLabel }) => !(isHorizontal || isTitleFormLabel) && 'margin-bottom: 8px;'}


  display: flex;
  align-items: center;
`;
export const ClearSelectedStyled = styled.div `
  padding: 10px 0 6px 6px;
  border-top: 1px solid ${colorCoreGray500};

  ${ADAPTIVE.minWidth.desktop} {
    margin-top: 4px;
  }
`;
export const MobileFilterButtonStyled = styled(MiniButton) `
  width: ${({ buttonWidth }) => buttonWidth};
  position: relative;

  ${({ isRightIcon }) => isRightIcon && 'justify-content: flex-start;'}

  ${boxStyled}
`;
export const FilterMobileMenuStyled = styled.ul `
  ${simpleFilterListReset};

  box-sizing: border-box;
  list-style: none;
  max-height: 246px;
  overflow-y: auto;
`;
export const FiltersListSimpleResetStyled = styled.ul `
  ${simpleFilterListReset};
`;
export const FilterMenuButtonStyled = styled(MiniButton) `
  width: 100%;
  display: flex;
  justify-content: space-between;

  ${getTextStyles('Ubuntu', 400, 16, 24)}
`;
export const FilterMenuItemStyled = styled.li `
  box-sizing: border-box;
  width: 100%;
  padding: 16px;

  ${getTextStyles('Ubuntu', 400, 16, 24)}

  &:not(:last-child) {
    box-shadow: inset 0 -1px 0 ${colorCoreGray500};
  }
`;
export const TitleStyled = styled.span `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const ResetFilterStyled = styled.button `
  border: none;
  background-color: transparent;
  cursor: pointer;

  ${getTextStyles('Ubuntu', 400, 16, 24)}
`;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const CloseIconStyled = styled(({ isRightToLeft, isDisabled, ...rest }) => (React.createElement(SVGIcon, { ...rest, pathFill: isDisabled ? colorCoreGray1000Base : undefined }))) `
  pointer-events: none;
  position: absolute;
  top: 10px;
  bottom: 10px;

  ${({ isRightToLeft }) => (isRightToLeft ? 'left: 10px;' : 'right: 10px;')};
`;
export const ModalWindowFooterStyled = styled(ModalWindowFooter) `
  ${ButtonsGroupInnerStyled} {
    button {
      width: 100%;

      ${ADAPTIVE.minWidth.desktop} {
        width: auto;
      }
      flex: 1 1 auto;

      &:first-child {
        flex: 0 1 auto;
        order: 1;
      }
    }
  }
`;
// Styles for CustomVerticalView
export const FlexWrapperStyled = styled(FlexWrapper) `
  ${({ isExpanded }) => (isExpanded ? 'height: 100%;' : 'height: 0px;')}

  animation: all 2s linear infinite;
`;
// ul
export const ListStyled = styled(FlexWrapper) `
  padding: 0 10px 16px 10px;
  margin: 0;
  margin-top: -6px;

  ${CustomScroll}
`;
export const ButtonFilterStyled = styled(FlexWrapper) `
  border: 0;

  background-color: transparent;
  cursor: pointer;
`;
export const DropDownFilterStyled = styled(FlexWrapper) `
  overflow: hidden;
  animation: all 2s linear infinite;

  &:not(:first-child) {
    ${ButtonFilterStyled} {
      ${({ isBorderTopNeeded }) => isBorderTopNeeded && `border-top:${extraSecondGrayColor} 1px solid;`}
    }
  }
`;
